// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"360":"04b4ff9b","800":"8760515d","854":"8d3519c3","1664":"8760515d","6412":"8760515d","6915":"7734b148","8284":"7615b153","8524":"8760515d"}[chunkId] + ".chunk.css";
};